import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import RequestServiceCodeContMain from "presentation/view/container/RequestServiceCode/RequestServiceCodeContMain";

CommonEntrypoint(<RequestServiceCodeContMain />)